import { elkPlanBUnlimAccum3HoursEnabled } from './elkPlanBUnlimAccum3HoursEnabled';

type GetAccumulatorFillType = {
  isUnlimited?: boolean;
  rest: number | string;
  size?: number | string;
};

export const getAccumulatorFill = ({ isUnlimited, rest, size }: GetAccumulatorFillType) => {
  const isElkUnlimAccum3HoursEnabled = elkPlanBUnlimAccum3HoursEnabled();
  const isFilled =
    isUnlimited && (!isElkUnlimAccum3HoursEnabled || (isElkUnlimAccum3HoursEnabled && !size));

  if (isFilled || !size || rest > size) {
    return 1;
  }

  return Number(rest) / Number(size);
};
